import ApiClient from ".."

// In DTOs
import JobGetMatchesIn from "../../dtos/in/JobGetMatchesIn"
import JobPostFavoritesIn from "../../dtos/in/JobPostFavoritesIn"
import JobPostFeedbackIn from "../../dtos/in/JobPostFeedbackIn"

// Out DTOs
import GenericOut from "../../dtos/out/GenericOut"
import JobGetListingsOut from "../../dtos/out/JobGetListingsOut"
import JobGetMatchedOut from "../../dtos/out/JobGetMatchedOut"
import JobGetOut from "../../dtos/out/JobGetOut"
import JobGetSuggestedOut from "../../dtos/out/JobGetSuggestedOut"

export class JobEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/job"

  /**
   * Retrieves a list of the authenticated user's suggested jobs.
   */
  async getSuggestedList() {
    return this.client.get<JobGetSuggestedOut>(JobEndpoints.BASE_URL, "/suggested")
  }

  /**
   * Retrieves a job with all it's additional details.
   */
  async get(jobId: number) {
    return this.client.get<JobGetOut>(JobEndpoints.BASE_URL, `/${jobId}`)
  }

  /**
   * Retrieves job listings for a specific job from Adzuna, based on the user's location.
   */
  async getJobListings(jobId: number) {
    return this.client.get<JobGetListingsOut>(JobEndpoints.BASE_URL, `/${jobId}/listings`)
  }

  /**
   * Retrieves jobs with either job name, industry name or function name matching search key.
   */
  async getJobMatches(payload: JobGetMatchesIn) {
    return this.client.get<JobGetMatchedOut>(JobEndpoints.BASE_URL, `/match`, payload)
  }

  /**
   * Adds or removes a job from the user's favorites.
   */
  async postFavorite(jobId: number, payload: JobPostFavoritesIn) {
    return this.client.post<GenericOut>(JobEndpoints.BASE_URL, `/${jobId}/favorite`, payload)
  }

  /**
   * Upsert the feedback for a job.
   */
  async postFeedback(jobId: number, payload: JobPostFeedbackIn) {
    return this.client.post<GenericOut>(JobEndpoints.BASE_URL, `/${jobId}/feedback`, payload)
  }
}
